import React from "react";

import { Route, Routes } from "react-router-dom";

import { Box } from "@mui/joy";

import Header from "./components/Header";
import PrivateWrapper from "./components/PrivateWrapper";
import Debug from "./components/Debug";
import Login from "./components/Login";
import AdminOverview from "./components/admin/AdminOverview";
import ConversationList from "./components/ConversationList";
import Conversation from "./components/Conversation";
import Document from "./components/Document";
import AdminKgManagement from "./components/admin/AdminKgManagement";
import Home from "./components/Home";
import { useSetupAnalytics } from "./util/analytics";
import ConstructabilityReviewWorkflow from "./components/workflow/ConstructabilityReviewWorkflow";
import RfiReviewWorkflow from "./components/workflow/RfiReviewWorkflow";
import NavigatorStorageViewer from "./components/admin/NavigatorStorageViewer";

function App() {
    useSetupAnalytics();

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
            }}
        >
            <Header />

            <Box
                sx={{
                    flex: "1 1 auto",
                    position: "relative",
                    overflowY: "auto",
                    display: "flex",
                }}
            >
                <Routes>
                    <Route
                        path="/"
                        element={
                            <PrivateWrapper>
                                <Home />
                            </PrivateWrapper>
                        }
                    />
                    <Route
                        path="/debug"
                        element={
                            <PrivateWrapper>
                                <Debug />
                            </PrivateWrapper>
                        }
                    />

                    <Route
                        path="/admin"
                        element={
                            <PrivateWrapper>
                                <AdminOverview />
                            </PrivateWrapper>
                        }
                    />

                    <Route
                        path="/admin/kg"
                        element={
                            <PrivateWrapper>
                                <AdminKgManagement />
                            </PrivateWrapper>
                        }
                    />

                    <Route
                        path="/admin/fileCache"
                        element={
                            <PrivateWrapper>
                                <NavigatorStorageViewer />
                            </PrivateWrapper>
                        }
                    />

                    <Route
                        path="/c"
                        element={
                            <PrivateWrapper>
                                <ConversationList />
                            </PrivateWrapper>
                        }
                    />

                    <Route
                        path="/c/:id"
                        element={
                            <PrivateWrapper>
                                <Conversation />
                            </PrivateWrapper>
                        }
                    />

                    <Route
                        path="/w/cr"
                        element={
                            <PrivateWrapper>
                                <ConstructabilityReviewWorkflow />
                            </PrivateWrapper>
                        }
                    />
                    <Route
                        path="/w/rfi"
                        element={
                            <PrivateWrapper>
                                <RfiReviewWorkflow />
                            </PrivateWrapper>
                        }
                    />

                    <Route
                        path="/doc/:id?/:fragmentNodeId?"
                        element={
                            <PrivateWrapper>
                                <Document />
                            </PrivateWrapper>
                        }
                    />

                    <Route path="/authenticate" element={<Login />} />
                </Routes>
            </Box>
        </Box>
    );
}

export default App;
